<template>
    <div id="manual-payment-posting-container">
        <b-row>
            <b-col class="col-12 mt-2">
                <h4 class="page-title text-truncate">{{ $t('PostPayment.Manual.Title') }}</h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12" v-if="hasPermissionAdd()">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="
                        false
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-on:click="AddHandler"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-bind:Name="'btn_add_payment'"
                >
                </MdButton>
            </b-col>
            <b-col :md="!hasPermissionAdd() ? 12 : 9" :lg="!hasPermissionAdd() ? 12 : 9" sm="12">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameters.searchCriteria"
                            @keyup.enter="searchAsync()"
                        />
                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="searchAsync"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="parameters.dateFrom"
                    @input="dateFromChanged($event)"
                    :Id="'payment-date-from'"
                    :Type="'date'"
                    :OnPressEnter="searchAsync"
                    :isConfirm="false"
                    :ReadOnly="searching"
                    :isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="parameters.dateTo"
                    @input="dateToChanged($event)"
                    :Id="'payment-date-to'"
                    :Type="'date'"
                    :OnPressEnter="searchAsync"
                    :isConfirm="false"
                    :ReadOnly="searching"
                    :isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.PaymentType')"
                    v-bind:Options="typeOptions"
                    v-bind:Model="typeVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownType"
                    :IsDisabled="searching"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.PaymentMethod')"
                    v-bind:Options="paymentTypeOptions"
                    v-bind:Model="paymentTypeVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownPaymentType"
                    :IsDisabled="searching"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$tc('Shared.Patient', 2)"
                    v-bind:ModelCode="patientCodeVModel"
                    v-bind:RefCode="'patientcode'"
                    v-bind:Api="'Patients'"
                    v-bind:FieldCode="'patientcode'"
                    v-bind:FieldDescription="'firstname'"
                    :SearchTitle="$tc('Shared.Patient', 2)"
                    :GetValues="getPatientValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'PatientCode'"
                    :AuxFields="patientAuxFields"
                    :FieldsDate="patientFieldsDate"
                    :ServerSidePagination="true"
                    v-bind:Fields="patientLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$tc('Insurance.Insurance', 1)"
                    v-bind:ModelCode="insuranceCodeVModel"
                    v-bind:RefCode="'InsuranceCode'"
                    v-bind:Api="'Insurances/Lookup'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$tc('Insurance.Insurance', 2)"
                    :GetValues="getInsuranceValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="insuranceLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="statusOptions"
                    v-bind:Model="statusVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownStatus"
                    :IsDisabled="searching"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$t('Shared.UserName')"
                    v-bind:ModelCode="userIdVModel"
                    v-bind:RefCode="'UserId'"
                    v-bind:Api="'Users/Lookup'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$t('Shared.UserName')"
                    :GetValues="getUserIdValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="userIdLookupFields"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.PayReference')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'payment-reference'"
                    v-bind:MaxLengthProp="50"
                    v-model="parameters.paymentReference"
                    v-bind:Id="'payment-reference'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.TransactionNo')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'transaction-number'"
                    v-model.number="parameters.transactionNumber"
                    v-bind:Id="'transaction-number'"
                />
            </b-col>
            <b-col class="col-6">
                <MdButton
                    v-bind:Label="$t('Shared.Search')"
                    v-bind:Name="'btnSearchPayment'"
                    v-bind:ClassProp="'secondary mx-2 btn-login pull-right mt-3'"
                    v-on:click="searchAsync"
                    :isReadOnly="searching"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col class="col-md-12">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:FieldsDate="fieldsDateArr"
                    v-bind:IsPaymentPostingListing="true"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :customActionButtons="customActionButtons"
                >
                </MdTable>
                <!--
                v-bind:VisibleEditIcon="hasPermissionEdit()"
                :editIconEvent="edit"
                -->
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Permission from '@/common/Permission';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import PostPaymentService from '@/services/postPayment.service';
import Utils from '@/common/utils.js';
import EnumService from '@/services/enum.service';

export default {
    name: 'InsurancePaymentPostingListing',
    mixins: [ShowMessage, DBFunctions, Permission],

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                favButtonAtion: false
            },
            isReadOnly: false,
            showMessageIsEmpty: false,
            fields: [
                {
                    key: 'paymentDate',
                    sortable: true,
                    label: this.$t('ClaimBatchStatus.payDate'),
                    class: 'text-center',
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                },
                {
                    key: 'transno',
                    sortable: true,
                    label: this.$t('Shared.TransactionNo'),
                    class: 'text-right'
                },
                {
                    key: 'paymentSourceType',
                    sortable: true,
                    label: this.$t('Shared.PaymentType'),
                    class: 'text-left',
                    formatter: value => {
                        return value.toLowerCase() === 'patient payment'
                            ? this.$t('ClaimBatchStatus.patientPayment')
                            : this.$t('PostPayment.Manual.InsurancePayment');
                    }
                },
                {
                    key: 'insuraceName',
                    sortable: true,
                    label: this.$t('Shared.colInsuranceName'),
                    class: 'text-left'
                },
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left'
                },
                {
                    key: 'paymentType',
                    sortable: true,
                    label: this.$t('Shared.PaymentMethod'),
                    class: 'text-left'
                },
                {
                    key: 'paymentReference',
                    sortable: true,
                    label: this.$tc('Shared.PayReference'),
                    class: 'text-left'
                },
                {
                    key: 'amount',
                    sortable: true,
                    label: this.$t('Shared.AmountValCode'),
                    class: 'text-right',
                    formatter: value => {
                        return Utils.formatterCurrent(value);
                    }
                },
                {
                    key: 'userName',
                    sortable: true,
                    label: this.$t('Shared.UserName'),
                    class: 'text-left'
                },
                {
                    key: 'sysDate',
                    sortable: true,
                    label: this.$t('Shared.Date'),
                    class: 'text-center',
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                }
            ],
            fieldsDateArr: ['paymentDate'],
            items: [],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            searching: false,
            parameters: {
                searchCriteria: '',
                dateFrom: null,
                dateTo: null,
                paymentSourceType: null,
                paymentStatus: null,
                paymentType: null,
                patientCodeList: [],
                insuranceCodeList: [],
                userIdList: [],
                paymentReference: null,
                transactionNumber: null
            },
            typeVModel: { value: 0, name: this.$t('Shared.All') },
            statusVModel: { value: 0, name: this.$t('Shared.All') },
            paymentTypeVModel: { value: 0, name: this.$t('Shared.All') },
            patientCodeVModel: [],
            insuranceCodeVModel: [],
            userIdVModel: [],
            isDateFromValid: true,
            isDateToValid: true,
            typeOptions: EnumService.PaymentPostType,
            statusOptions: EnumService.PaymentPostStatus,
            paymentTypeOptions: EnumService.PaymentPostPaymentType,
            selectPlaceholder: '',
            patientAuxFields: ['lastname'],
            patientFieldsDate: ['dob'],
            patientLookupFields: [
                { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                { key: 'lastname', sortable: true, label: this.$t('Shared.LastName') },
                { key: 'patientcode', sortable: true, label: this.$t('Shared.Code') },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob') }
            ],
            insuranceLookupFields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description')
                },
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.Code')
                }
            ],
            userIdLookupFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.UserName') },
                { key: 'code', sortable: true, label: this.$t('doctor.UserCode') }
            ],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            customActionButtons: [
                {
                    id: 'edit-draft-payment',
                    visible: item => this.editIconVisibleHandler(item),
                    icon: 'med-pen',
                    handler: item => this.edit(item),
                    tooltip: this.$t('Shared.Edit')
                },
                {
                    id: 'view-payment',
                    visible: item => !this.editIconVisibleHandler(item),
                    icon: 'med-play-mini',
                    handler: item => this.view(item),
                    tooltip: this.$t('Shared.View')
                },
                {
                    id: 'process_pay',
                    visible: item => this.editIconVisibleHandler(item),
                    icon: 'med-insurance',
                    handler: item => this.processPay(item),
                    tooltip: this.$t('PostPayment.Manual.ProcessPay')
                }
            ]
        };
    },

    methods: {
        editIconVisibleHandler(item) {
            return item.paymentStatus && item.paymentStatus.toLowerCase() === 'draft';
        },

        edit(item) {
            const paymentSourceType =
                item.paymentSourceType.toLowerCase() === 'patient payment'
                    ? 'patient'
                    : 'insurance';
            this.$router
                .push({
                    name: 'manual-payment-posting-edit',
                    params: { id: item.transno, source: paymentSourceType }
                })
                .catch(() => {});
        },

        view(item) {
            const paymentSourceType =
                item.paymentSourceType.toLowerCase() === 'patient payment'
                    ? 'patient'
                    : 'insurance';

            this.$router
                .push({
                    name: 'manual-payment-posting-view',
                    params: { id: item.transno, source: paymentSourceType }
                })
                .catch(() => {});
        },

        AddHandler() {
            this.$router
                .push({
                    name: 'manual-payment-posting-add'
                })
                .catch(() => {});
        },

        onRowSelected() {},

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        dateFromChanged(value) {
            this.parameters.dateFrom = value;
            this.searchAsync();
        },

        dateToChanged(value) {
            this.parameters.dateTo = value;
            this.searchAsync();
        },

        changeDropDownType(value) {
            this.parameters.paymentSourceType = value ? value.value : null;
            this.searchAsync();
        },

        changeDropDownStatus(value) {
            this.parameters.paymentStatus = value ? value.value : null;
            this.searchAsync();
        },

        changeDropDownPaymentType(value) {
            this.parameters.paymentType = value ? value.value : null;
            this.searchAsync();
        },

        getPatientValues(values) {
            this.patientCodeVModel = values;
            this.parameters.patientCodeList = values || [];
            this.searchAsync();
        },

        getInsuranceValues(value) {
            this.insuranceCodeVModel = value || [];
            this.parameters.insuranceCodeList = value || [];
            this.searchAsync();
        },

        getUserIdValues(value) {
            this.userIdVModel = value || [];
            this.parameters.userIdList = value || [];
            this.searchAsync();
        },

        searchAsync() {
            this.currentPage = 1;
            this.listingAsync();
        },

        listingAsync() {
            if (this.parameters.dateFrom && this.parameters.dateTo) {
                const result = Utils.validateDateRange(
                    this.parameters.dateFrom,
                    this.parameters.dateTo
                );

                if (!result.valid) {
                    this.isDateToValid = !result.fields.includes('toDate');
                    this.isDateFromValid = !result.fields.includes('fromDate');
                    this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                    return;
                }

                this.isDateToValid = true;
                this.isDateFromValid = true;
            } else {
                this.isDateToValid =
                    !this.parameters.dateTo || Utils.isValidDate(this.parameters.dateTo);
                this.isDateFromValid =
                    !this.parameters.dateFrom || Utils.isValidDate(this.parameters.dateFrom);

                if (!this.isDateToValid || !this.isDateFromValid) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );

                    return;
                }
            }

            this.searching = true;
            this.parameters.PageNumber = this.currentPage;
            this.parameters.PageSize = this.perPage;
            PostPaymentService.getManualPayment(this.parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        this.items.forEach(item => {
                            item.paymentStatusTranslated =
                                item.paymentStatus &&
                                item.paymentStatus.toLowerCase() === 'finalized'
                                    ? this.$t('Shared.Finalized')
                                    : this.$t('PostPayment.Manual.Draft');
                        });

                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.items.length === 0;
                    this.searching = false;
                })
                .catch(error => {
                    this.searching = false;
                    this.showResponseErrorMessage(error);
                });
        },

        async processPay(item) {
            try {
                await PostPaymentService.canProcessPayment(item.transno);

                const response = await PostPaymentService.processInsurancePay({
                    headerId: item.transno
                });

                setTimeout(
                    () =>
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('PostPayment.Manual.PaymentSuccessfullyMsg', {
                                TransNumber: response.data.transactionNumber
                            }),
                            'success'
                        ),
                    50
                );

                this.searchAsync();
            } catch (error) {
                console.log(error);
                this.showResponseErrorMessage(error);
            }
        },

        async initializeData() {},

        async initializeListingAsync() {
            await this.listingAsync(false);
        },

        setupEventListeners() {},

        cleanupEventListeners() {}
    },

    created() {
        this.setupEventListeners();
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;

        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        await this.initializeData().then(() => this.$nextTick(() => this.initializeListingAsync()));
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        this.cleanupEventListeners();
    }
};
</script>
